import React, { FC, ReactNode } from "react";

import { BaseComponentProps } from "@keepeek/refront-components";

import DefaultLayout from "../../../containers/Layout";

export type MediaPageLayoutProps = {
  children: ReactNode;
  templateFooter?: ReactNode;
} & BaseComponentProps;

const MediaPageLayout: FC<React.PropsWithChildren<MediaPageLayoutProps>> = function ({
  children,
  templateFooter,
}) {
  return (
    <DefaultLayout
      sx={{
        // Override minHeight of the default layout to avoid white line on the bottom of the page
        "#main": {
          minHeight: "unset !important",
        },
      }}
    >
      <>
        {children}
        {templateFooter}
      </>
    </DefaultLayout>
  );
};

export default MediaPageLayout;
